// =========================================================
// SECTION MARQUES v2 (Figma 432:254) — onglets de catégories + Splide.
// Le filtrage RECONSTRUIT le splide (destroy(true) restaure le DOM d'origine,
// on replace les slides filtrées, on remonte) : masquer des slides en
// display:none casse la géométrie loop/clones de Splide (chemin sûr).
// =========================================================
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-marques').forEach((section) => {
        const el = section.querySelector('.km-marques__splide');
        if (!el || el.dataset.kmMarquesInitialized) return;
        el.dataset.kmMarquesInitialized = '1';

        const list = el.querySelector('.splide__list');
        // photocopie des slides AVANT le premier mount (Splide clone/annote le DOM)
        const allSlides = [...list.children].map((s) => s.cloneNode(true));

        const options = {
            type: 'loop',
            perPage: 3, // cartes logo + nom + description (maquette v2)
            perMove: 1,
            gap: '3rem',
            pagination: false,
            arrows: false,
            autoplay: true,
            interval: 3500,
            pauseOnHover: true,
            pauseOnFocus: false,
            speed: 800,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            reducedMotion: {speed: 800, rewindSpeed: 800}, // glisse conservée (politique Olivier)
            breakpoints: {
                991: {perPage: 2},
                // mobile : bullets de navigation (pattern promos/news — retour Olivier)
                767: {perPage: 1, gap: '1.5rem', pagination: true},
            },
        };

        let splide = new Splide(el, options).mount();

        // ----- Onglets (desktop) + liste déroulante (mobile) : reconstruire
        // le carousel sur la catégorie choisie, les deux synchronisés -----
        const tabs = section.querySelectorAll('.km-marques__tab');
        const select = section.querySelector('.km-marques__select');

        const applyFilter = (filter) => {
            tabs.forEach((t) => {
                const active = t.dataset.filter === filter;
                t.classList.toggle('is-active', active);
                t.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            if (select && select.value !== filter) select.value = filter;
            splide.destroy(true); // restaure le markup pré-mount
            const freshList = el.querySelector('.splide__list');
            freshList.replaceChildren(
                ...allSlides
                    .filter((s) => !filter || s.dataset.category === filter)
                    .map((s) => s.cloneNode(true))
            );
            splide = new Splide(el, options).mount();
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                if (tab.classList.contains('is-active')) return;
                applyFilter(tab.dataset.filter);
            });
        });
        if (select) {
            select.addEventListener('change', () => applyFilter(select.value));
        }

        // ----- Au 1er chargement avec onglets : ne montrer que la 1ʳᵉ catégorie -----
        const first = section.querySelector('.km-marques__tab.is-active');
        if (first) {
            splide.destroy(true);
            const freshList = el.querySelector('.splide__list');
            freshList.replaceChildren(
                ...allSlides
                    .filter((s) => s.dataset.category === first.dataset.filter)
                    .map((s) => s.cloneNode(true))
            );
            splide = new Splide(el, options).mount();
        }
    });

});

// ----- Page Marques : filtres par catégorie + « VOIR PLUS » -----
// (retours Olivier : ne pas tout afficher d'un coup, et une pagination UX —
// bouton « Voir plus » qui révèle 16 cartes de plus sans perdre le contexte,
// avec compteur ; reset à chaque changement de filtre)
document.addEventListener('DOMContentLoaded', () => {
    const wrap = document.querySelector('.km-marques-page');
    if (!wrap) return;
    const STEP = 16; // 4 colonnes × 4 rangées desktop
    const buttons = wrap.querySelectorAll('.km-marques-page__filter');
    const cards = [...wrap.querySelectorAll('.km-marque-card')];
    const grid = wrap.querySelector('.km-marques-page__grid');
    let filter = '*';
    let shown = STEP;

    const more = document.createElement('div');
    more.className = 'km-marques-page__more';
    const count = document.createElement('p');
    count.className = 'km-marques-page__count';
    count.setAttribute('aria-live', 'polite');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'km-btn km-btn--light km-marques-page__more-btn';
    btn.addEventListener('click', () => {
        shown += STEP;
        render();
    });
    more.append(count, btn);
    grid.after(more);

    const matches = () => cards.filter((c) => filter === '*' || c.dataset.category === filter);

    function render() {
        const list = matches();

        cards.forEach((c) => c.classList.add('is-hidden'));
        list.slice(0, shown).forEach((c) => {
            c.classList.remove('is-hidden');
            // une carte révélée après coup ne doit pas rester masquée par la
            // garde CSS [data-anim] (son trigger GSAP a pu passer pendant
            // qu'elle était en display:none)
            if (c.hasAttribute('data-anim')) {
                c.removeAttribute('data-anim');
                c.style.opacity = '';
                c.style.transform = '';
            }
        });

        const visible = Math.min(shown, list.length);
        count.textContent = `${visible} marque${visible > 1 ? 's' : ''} affichée${visible > 1 ? 's' : ''} sur ${list.length}`;
        const remaining = list.length - visible;
        btn.textContent = remaining > 0
            ? `Voir plus de marques (${remaining})`
            : '';
        btn.hidden = remaining <= 0;
    }

    // chips (desktop) et liste déroulante native (mobile) pilotent le même filtre
    const select = wrap.querySelector('.km-marques-page__select');

    function applyFilter(f) {
        filter = f;
        shown = STEP;
        buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.filter === f));
        if (select && select.value !== f) select.value = f;
        render();
    }

    buttons.forEach((b) => {
        b.addEventListener('click', () => applyFilter(b.dataset.filter));
    });
    if (select) {
        select.addEventListener('change', () => applyFilter(select.value));
    }

    render();
});
